export const auctionItems = [
  {
    id: "1",
    caseNumber: "2025타경52341",
    court: "인천지방법원",
    location: "인천 미추홀구 용현동",
    propertyType: "아파트",
    appraisedValue: 320000000,
    minimumPrice: 224000000,
    auctionDate: "2026-06-15",
    failureCount: 1,
    hasTenant: false,
    rightsAnalysis: "말소기준권리 확인 완료, 선순위 임차인 없음",
    expectedSalePrice: 380000000,
    expectedProfit: 156000000,
    grade: "A",
    exclusiveArea: 85,
    buildingAge: 20,
    imagePrompt: "modern clean apartment building exterior in Incheon Korea, bright sunny day, professional real estate photography style, simple white background tones, minimalist architecture, warm lighting",
    imageUrl: "https://img.echotwin.kr/kangstudy/d809ee77f1052774.jpg",
  },
  {
    id: "2",
    caseNumber: "2025타경68902",
    court: "서울중앙지방법원",
    location: "서울 관악구 봉천동",
    propertyType: "다세대",
    appraisedValue: 250000000,
    minimumPrice: 175000000,
    auctionDate: "2026-06-18",
    failureCount: 2,
    hasTenant: true,
    rightsAnalysis: "임차인 2명 확인, 보증금 합계 120,000,000원, 대항력 있음",
    expectedSalePrice: 300000000,
    expectedProfit: 125000000,
    grade: "B",
    exclusiveArea: 65,
    buildingAge: 25,
    imagePrompt: "multi-family residential building in Gwanak-gu Seoul Korea, clean urban streetscape, professional real estate photography, soft natural lighting, simple neutral background",
    imageUrl: "https://img.echotwin.kr/kangstudy/aaf37b2e2400aef7.jpg",
  },
  {
    id: "3",
    caseNumber: "2025타경41057",
    court: "수원지방법원",
    location: "경기 수원시 영통구 망포동",
    propertyType: "아파트",
    appraisedValue: 450000000,
    minimumPrice: 315000000,
    auctionDate: "2026-06-22",
    failureCount: 0,
    hasTenant: false,
    rightsAnalysis: "근저당권 말소 가능, 후순위 권리 없음, 명도 용이",
    expectedSalePrice: 520000000,
    expectedProfit: 205000000,
    grade: "A",
    exclusiveArea: 102,
    buildingAge: 10,
    imagePrompt: "modern high-rise apartment complex in Yeongtong Suwon Korea, clean contemporary architecture, bright daytime, professional real estate image, crisp white tones, warm sunlight",
    imageUrl: "https://img.echotwin.kr/kangstudy/e106f3e9f0600128.jpg",
  },
  {
    id: "4",
    caseNumber: "2025타경78123",
    court: "대전지방법원",
    location: "대전 서구 둔산동",
    propertyType: "오피스텔",
    appraisedValue: 180000000,
    minimumPrice: 126000000,
    auctionDate: "2026-06-25",
    failureCount: 1,
    hasTenant: true,
    rightsAnalysis: "임차인 1명, 보증금 50,000,000원, 배당요구 종기 도과 주의",
    expectedSalePrice: 210000000,
    expectedProfit: 84000000,
    grade: "B",
    exclusiveArea: 33,
    buildingAge: 8,
    imagePrompt: "modern officetel building in Dunsan-dong Daejeon Korea, clean urban setting, professional architecture photography, soft daytime light, neutral background tones",
    imageUrl: "https://img.echotwin.kr/kangstudy/0a5e794d43dc4505.jpg",
  },
  {
    id: "5",
    caseNumber: "2025타경33981",
    court: "부산지방법원",
    location: "부산 해운대구 우동",
    propertyType: "아파트",
    appraisedValue: 680000000,
    minimumPrice: 476000000,
    auctionDate: "2026-06-28",
    failureCount: 0,
    hasTenant: false,
    rightsAnalysis: "말소기준권리 1순위, 권리관계 깨끗함, 투자가치 높음",
    expectedSalePrice: 780000000,
    expectedProfit: 304000000,
    grade: "A",
    exclusiveArea: 115,
    buildingAge: 12,
    imagePrompt: "luxury apartment tower in Haeundae Busan Korea, ocean view district, premium real estate photography, bright sunny coastal atmosphere, clean modern exterior",
    imageUrl: "https://img.echotwin.kr/kangstudy/0edca693d45d26cf.jpg",
  },
  {
    id: "6",
    caseNumber: "2025타경90512",
    court: "인천지방법원",
    location: "인천 부평구 부평동",
    propertyType: "아파트",
    appraisedValue: 210000000,
    minimumPrice: 147000000,
    auctionDate: "2026-07-02",
    failureCount: 3,
    hasTenant: false,
    rightsAnalysis: "3회 유찰로 최저가 하락, 임차인 없음, 수익성 양호",
    expectedSalePrice: 250000000,
    expectedProfit: 103000000,
    grade: "C",
    exclusiveArea: 72,
    buildingAge: 28,
    imagePrompt: "residential apartment building in Bupyeong-gu Incheon Korea, standard Korean apartment complex, clean daytime photography, simple background, natural lighting",
    imageUrl: "https://img.echotwin.kr/kangstudy/b2ee8b2ba2c86c8a.jpg",
  },
];

export const regions = ["전체", "서울", "경기", "인천", "부산", "대전", "대구", "광주", "울산"];
export const propertyTypes = ["전체", "아파트", "다세대", "오피스텔", "단독주택", "상가"];
export const grades = ["전체", "A", "B", "C"];